import React from 'react';
import './Events.css';


export const Events = () => {
	

	const eventsData = [
		{ date: '2027-01-07', name: 'Roody Giesing', location: 'München', link: 'https://www.roody-giesing.de/event-details/mondwild', time: '21:00-22:00'},
		{ date: '2026-11-19', name: 'Lowkey Local, Milla Club', location: 'München', link: 'https://rausgegangen.de/en/events/lowkey-local-0/',  time: '20:00'},

		{ date: '2026-09-16', name: 'Sprungbrett Liveshow, Kranhalle', location: 'München', link: 'https://www.feierwerk.de/fachstelle-pop/workshops-veranstaltungen/alle-termine/detail/16-09-2026_sprungbrett-liveshow-i',  time: '19:00'},
		{ date: '2026-09-04', name: 'Isarinselfest, Praterinsel', location: 'München', link: 'https://www.isarinselfest.de/',  time: '19:00-20:00'},


		{ date: '2026-08-14', name: 'Alles Gute Festival, Botanica Garden Stage', location: 'Innsbruck', link: 'https://allesgutefestival.at/', time: '20:30-21:30'},
		{ date: '2026-07-27', name: 'Kulturstrand', location: 'München', link: 'https://www.instagram.com/kulturstrand_muenchen', time: '19:30' },
		{ date: '2026-07-06', name: 'Kulturstrand', location: 'München', link: 'https://www.instagram.com/kulturstrand_muenchen', time: '19:30' },
		{ date: '2026-06-05', name: 'StuStaCulum, Dada Außenbühne', location: 'München', link: 'https://www.stustaculum.de/en' , time: '19:50-21:00'},
		{ date: '2026-06-03', name: 'Schienenbuskonzert, Minna Thiel', location: 'München', link: 'https://minnathiel.de/programm/' , time: '20:00'},
		{ date: '2026-05-16', name: 'Krachparade, Geschwister-Scholl-Platz', location: 'München', link: 'https://mehrlaermfuermuenchen.jimdofree.com/', time: '14:10-14:30'},
		{ date: '2026-05-14', name: 'Coll:b am Hof', location: 'Innsbruck', link: 'https://www.collabamhof.at/', time: '17:30-18:00' },
		{ date: '2026-04-23', name: 'Vorband für PRINCIPESS, Dekadenz', location: 'Brixen', link: 'https://www.dekadenz.it/de/aktuelle-spielzeit/451-moling-viechtl-staffler.html' },
		{ date: '2026-02-18', name: 'Milla Song Slam', location: 'München', link: 'https://milla-club.de/milla-song-slam-23/' },
	]

	const eventsDataSingerSongwriter = [


		{ date: '2024-01-13', name: 'innen:welt', location: 'Café Kult, München', link: null },
		{ date: '2024-02-09', name: 'Opener für Felix Kramer', location: 'Dekadenz, Brixen', link: null },

		{ date: '2023-12-18', name: 'Märchenbazar (Wannda Bühne)', location: 'München', link: null },
		{ date: '2023-12-17', name: 'Milla Song Slam', location: 'München', link: null },
		{ date: '2023-11-23', name: 'Café Mellow', location: 'München', link: null },
		{ date: '2023-11-17', name: 'Treibhaus Acts', location: 'München', link: null },
		{ date: '2023-10-28', name: "Women's Bodies Project", location: 'Astra Brixen', link: null },
		{ date: '2023-09-29', name: 'Live im Lihotzky', location: 'München', link: null },
		{ date: '2023-06-07', name: 'Café Gans am Wasser', location: 'München', link: null },
		{ date: '2023-05-31', name: 'Alte Utting', location: 'München', link: null },
		{ date: '2023-03-25', name: 'Feierwerk Sessions', location: 'München', link: null },
		{ date: '2020-02-28', name: 'Live im Lihotzky', location: 'München', link: null },
		{ date: '2019-12-15', name: 'Zauberhafter Weihnachtsmarkt, Werksviertel Mitte', location: 'München', link: null },
		{ date: '2019-11-16', name: 'Beats For Needs: Benefizkonzert der UNICEF HSG', location: 'München', link: null },
		{ date: '2019-09-21', name: 'Music Universe DAH, Kulturschranne', location: 'Dachau', link: null },
		{ date: '2019-09-07', name: 'Szene Check Feierwerk Funkstation', location: 'München', link: null },
		{ date: '2019-06-29', name: 'Konvolut bei der Brucker Kulturnacht 2019', location: 'Fürstenfeldbruck', link: null },
		{ date: '2019-05-04', name: 'Lange Musik der Nacht - Minna Thiel', location: 'München', link: null },
		{ date: '2019-04-04', name: 'Singer // Songwriter // Lifesaver', location: 'München', link: null },
		{ date: '2019-04-01', name: 'Opener für Beans On Toast, Feierwerk', location: 'München', link: null },
		{ date: '2018-10-26', name: 'Opener für Moorea Masa, UFO', location: 'Bruneck', link: null },
	]


	const todayStr = new Date().toISOString().split('T')[0];

	const upcomingEvents = eventsData
		.filter(e => e.date >= todayStr)
		.sort((a, b) => a.date.localeCompare(b.date));

	const pastEvents = eventsData
		.filter(e => e.date < todayStr)
		.sort((a, b) => b.date.localeCompare(a.date));


	return (
		<section id="events">
			<div className="text-card-container">
				<h1 className="section-header">Events</h1>

				{/* Upcoming Events */}
				{upcomingEvents.length > 0 && (
					<>
						<h4>Anstehend</h4>
						<table>
							<tbody>
								{upcomingEvents.map((event) => (
									<tr key={event.date + event.name}>
										<td>{new Date(event.date).toLocaleDateString('de-DE')}</td>
										<td>

											{event.link ? (
												<a href={event.link} target="_blank" rel="noreferrer">
													{event.name}, {event.location}
													{event.time && ` (${event.time} Uhr)`}
												</a>
											) : (
												<>
													{event.name}, {event.location}
													{event.time && ` (${event.time} Uhr)`}
												</>
											)}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</>
				)}


				{/* Past Events */}




				{pastEvents.length > 0 && (
					<>
						<br />
						<br />
						<h4>Vergangen</h4>
						<table>
							<tbody>
								{pastEvents.map((event) => (
									<tr key={event.date + event.name}>
										<td>{new Date(event.date).toLocaleDateString('de-DE')}</td>
										<td>
											{event.link ? (
												<a href={event.link} target="_blank" rel="noreferrer" style={{ color: "inherit", textDecoration: "none" }}>
													{event.name}, {event.location}
												</a>
											) : (
												`${event.name}, ${event.location}`
											)}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</>
				)}



				{eventsDataSingerSongwriter.length > 0 && (
					<>
						<br />
						<br />
						<h4 className="past-event">Vergangen (Vorheriges Projekt als Singer-Songwriterin, akustisch)</h4>

						<table>
							<tbody>
								{eventsDataSingerSongwriter.map((event) => (
									<tr key={event.date + event.name} className="past-event">
										<td>{new Date(event.date).toLocaleDateString('de-DE')}</td>
										<td>
											{event.link ? (
												<a href={event.link} target="_blank" rel="noreferrer">
													{event.name}, {event.location}
												</a>
											) : (
												`${event.name}, ${event.location}`
											)}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</>
				)}
			</div>
		</section>
	);


}